export const EVENT_AUDIT = `
	query searchAuditHistory($audit: AuditInput!, $offset: Uint, $items_per_page: Uint, $overview: Boolean) {
		searchAuditHistory(audit: $audit, offset: $offset, items_per_page: $items_per_page, overview: $overview) {
			nodes {
				id
				auth_id
				auth_type
				email
				action
				type
				name
				payload
				details
				outcome
				count
				updated_at
				created_at
			}
			page_info {
				has_next_page
				total_count
			}
		}
	}
`;
